import type { ReduxActions, ReduxState } from './storeCore';
import type { Dispatch } from 'redux';

/**
 * Holds the store instance separately from `storeSetup` so that modules
 * needing the store outside of components (see `store.ts`) do not import
 * `storeSetup` and create a circular dependency (`storeSetup` -> reducers ->
 * ... -> `store.ts` -> `storeSetup`), which can evaluate `storeSetup` while
 * `storeCore` is mid-evaluation (`rootReducer` still undefined).
 *
 * Only type-level imports are allowed in this file.
 */

export type ReduxStore = {
  dispatch: Dispatch<ReduxActions>;
  subscribe: (fn: () => void) => void;
  getState: () => ReduxState;
};

let store: ReduxStore | null = null;

export const setStore = (instance: ReduxStore) => {
  store = instance;
};

export const getStore = () => store;
